var map = {
	"./1.png": 3902,
	"./2.png": 9111,
	"./3.png": 2695,
	"./4.png": 4099,
	"./5.png": 4355,
	"./6.png": 5254,
	"./7.png": 7559,
	"./8.png": 4729,
	"./9.png": 9001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9830;